import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["confirmation"];
  static values = { photoMessage: String, documentMessage: String };

  confirmUpload(event) {
    const uploadedFile = event.target.files[0];
    console.log(this.confirmationTarget);
    this.confirmationTarget.style.backgroundColor = "#4CAF50";
    // this.element.querySelector('i').style.display = "none";
    if (this.confirmationTarget.classList.contains("photo-upload")) {
      this.confirmationTarget.innerText = `${this.photoMessageValue} !(${uploadedFile.name})`;
    } else {
      this.confirmationTarget.innerText = `${this.documentMessageValue} !(${uploadedFile.name})`;
    }
    this.confirmationTarget.style.color = "white";
    this.element.style.boxShadow = "none";
  }
}
